export { default, type OwnProps as TrackWrapperProps } from './TrackWrapper';
